'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withStepper = undefined;

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _getContext = require('recompose/getContext');

var _getContext2 = _interopRequireDefault(_getContext);

var _setDisplayName = require('recompose/setDisplayName');

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = require('recompose/wrapDisplayName');

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _entities = require('./entities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A HOC to inject the stepperContext as properties
 */
var withStepper = exports.withStepper = function withStepper(WrappedComponent) {
  return (0, _compose2.default)((0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(WrappedComponent, 'withStepper')), (0, _getContext2.default)(_entities.stepperContext))(WrappedComponent);
};
//# sourceMappingURL=with-stepper.js.map



//////////////////
// WEBPACK FOOTER
// ./dist/src/with-stepper.js
// module id = 64
// module chunks = 0